import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { style: {"color":"gray"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Add Comment ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_comment = _resolveComponent("a-comment")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_list, {
      class: "demo-loadmore-list",
      loading: _ctx.initLoading,
      "item-layout": "horizontal",
      "data-source": _ctx.invoice.invoice_queries
    }, {
      renderItem: _withCtx(({ item }) => [
        _createVNode(_component_a_list_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_skeleton, {
              avatar: "",
              title: false,
              loading: !!item.loading,
              active: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_list_item_meta, {
                  description: item.message
                }, {
                  title: _withCtx(() => [
                    (item.user_id )
                      ? (_openBlock(), _createElementBlock("a", _hoisted_1, _toDisplayString(item.user.first_name) + " " + _toDisplayString(item.user.last_name) + "  ", 1))
                      : _createCommentVNode("", true),
                    (item.vendor_id)
                      ? (_openBlock(), _createElementBlock("a", _hoisted_2, _toDisplayString(item.vendor.vendor_name) + "  ", 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("small", _hoisted_3, _toDisplayString(item.date), 1)
                  ]),
                  avatar: _withCtx(() => [
                    _createVNode(_component_a_avatar, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_UserOutlined)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["description"])
              ]),
              _: 2
            }, 1032, ["loading"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["loading", "data-source"]),
    _createVNode(_component_a_comment, null, {
      avatar: _withCtx(() => [
        _createVNode(_component_a_avatar, null, {
          default: _withCtx(() => [
            _createVNode(_component_UserOutlined)
          ]),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_textarea, {
              value: _ctx.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
              placeholder: "Write a comment....",
              rows: 4
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { style: {"display":"table"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              loading: _ctx.submitting,
              type: "primary",
              onClick: _ctx.handleSubmit
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Form, {
      ref: "message_form",
      title: "Message"
    }, null, 512)
  ], 64))
}